import Dexie, { Table } from 'dexie';

export interface GeoJSONRecord {
  mapName: string;
  data: any;
}

export interface GeoJSONDB {
  geojson: Table<GeoJSONRecord, string>;
}

const db = new Dexie('GeoJSONDatabase') as Dexie & GeoJSONDB;

db.version(1).stores({
  geojson: 'mapName',
});

db.geojson = db.table('geojson');

// Helper functions
export const getGeoJSONDB = async (mapName: string): Promise<GeoJSONRecord | undefined> => {
  return db.geojson.get(mapName);
};

export const storeGeoJSONDB = async (mapName: string, data: any): Promise<void> => {
  await db.geojson.put({ mapName, data });
};

export const clearGeoJSONDB = async (): Promise<void> => {
  await db.geojson.clear();
};

export default db;
